import { mapGetters } from "vuex";
import number from "../../../../libs/number";
import moment from "moment";
import "moment/locale/fr";

moment.locale("fr");

const ElementMixin = {
	data: function () {
		return {
		};
	},
	props: {
		parent_data: null,
		property: "",
		editable: false
	},
	computed: {
		...mapGetters([ "editor", "active_study" ]),
		value: function () {
			if(this.parent_data)
				return this.parent_data[this.property];
			return undefined;
		},
		is_editable: function () {
			return (this.editable && this.editor.mode == "editing");
		}
	},
	methods: {
		moneyParse (value){
			value = value.toString();
			let decimalPart="";
			if(value.includes(".")){
				// remove the decimal part before the parsing
				decimalPart=value.slice(value.indexOf("."));
				value=value.slice(0,value.indexOf("."));
			}
			value=value.split("").reverse().join("");
			let newValue="";
			for(let i = 0 ; i<value.length ; i++){
				if(i%3==0 && i!=0){
					newValue+=" ";
				}
				newValue+=value[i];
			}
			value=newValue;
			value=value.split("").reverse().join("");
			if(decimalPart!==""){
				value+=decimalPart;
			}
			return value;
		},
		edit_study: function (new_value) {
			if (this.is_editable) {
				// check if new_value is a number with a ',' as a decimal separator
				if (number.is_number(new_value)) {
					new_value = number.clean(new_value).toString();
					// console.log('cleaning number: from', original, 'to', new_value);
				}
				
				
				// Update of the VueX Store
				this.$store.dispatch("edit_object", {
					obj: this.parent_data, // this.obj,
					field: this.property, // this.field,
					value: new_value,
				});
			}
			this.$store.dispatch("save_study");
		},

		round_100 (n, decimals=1) {
			// console.log('round_100 of', n);
			let numb = parseFloat(n);
			if (typeof (numb) != "number" || isNaN(numb)) {
				// console.log("not a number", n, typeof(numb));
				return n;
			}
			if (numb < 1000) {
				if (numb % 1 != 0) { // number has decimals
					return numb.toFixed(decimals);
				}
				return numb;
			}
			else if (numb < 10000) {
				numb = Math.round(numb / 10) * 10;
			}else{
				numb = Math.round(numb / 100) * 100;
			}
			let str_rounded =  this.moneyParse(numb);
			return str_rounded;
		},
	},
	filters: {
		format_date: function (date) {
			return moment(date, "YYYYMMDD").format("MMMM YYYY");
		}
	}
};

export default ElementMixin;